<template src="./AppointmentPerformed.html"></template>
<script>
import mixins from "../../../../../Mixins.js";
export default {
  mixins: [mixins],
    data(){
        return {
            appointmentPerformed: [],
        }
    },  
    mounted: function() {
    const vm = this;
    vm.init();
    },
    methods: {
    init() {
      const vm = this;
      vm.getPendingSchedule();
    },
    getPendingSchedule() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "webclinics/appointments/performed?status=HISTORY_CONCLUDED&page=0&size=20&sort=id,desc",
          {
            headers: { Authorization: vm.$session.get("bearer") },
            options: {
              page: 0,
              size: 10,
              sort: ["id", "desc"]
            }
          }
        )
        .then(function(response) {
          vm.appointmentPerformed = response.data.content;
          for(let appointment in vm.appointmentPerformed){
            vm.appointmentPerformed[appointment].price = vm.maskMoney(vm.appointmentPerformed[appointment].price);
          }
        });
    }
  }
};
</script>
<style lang="scss" src="./AppointmentPerformed.scss">
</style>